import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoachSettingsGeneralDiplomaController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-diploma/coach-settings-general-diploma.controller';

@Component({
	selector: 'spr-coach-settings-general-diploma-header',
	templateUrl: './coach-settings-general-diploma-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'md:block hidden',
	},
})
export class CoachSettingsGeneralDiplomaHeaderComponent {
	constructor(public controller: CoachSettingsGeneralDiplomaController) {}
}
